import { ReduxState } from '@/utils/typeHelpers'
import { createSelector } from 'reselect'
import {
  YearEndModuleStatusOptions,
  YearEndModuleType,
} from './yearEndModuleStatus.slice'

export const getYearEndModuleStatusesByType = (state: ReduxState) =>
  state.yearEndModuleStatuses.byModuleType
export const getYearEndModuleStatuses = (state: ReduxState) =>
  state.yearEndModuleStatuses.allModules

/** False until the modules load, so an empty list never reads as "all done". */
export const selectAllYearEndModulesComplete = createSelector(
  getYearEndModuleStatuses,
  (modules) =>
    modules.length > 0 &&
    modules.every(
      (module) => module.status === YearEndModuleStatusOptions.complete
    )
)
export const selectTaxQuestionnaireYearEndModuleStatus = createSelector(
  getYearEndModuleStatusesByType,
  (byModuleType) => byModuleType[YearEndModuleType.taxQuestionnaire]?.status
)

export const getCompleteYearEndModuleStatuses = createSelector(
  getYearEndModuleStatuses,
  (modules) =>
    modules.filter(
      (module) => module.status === YearEndModuleStatusOptions.complete
    )
)
